<template>
  <div>
    <el-dialog title="增加按钮"  :close-on-click-modal="false"  :visible.sync="addDialogVisible" class="imgbox" width="50%" :before-close="resetForm" :append-to-body="true">
      <el-form resetFields label-width="80px" ref="ruleForm"  :rules="rules" :model="form">
        <el-form-item label="按钮名称" prop="buttonName">
          <el-input maxlength="20" v-model.trim="form.buttonName" autocomplete="off" placeholder="请输入按钮名称"></el-input>
        </el-form-item>
        <el-form-item maxlength="20" label="按钮标识" prop="buttonValue">
          <el-input v-model.trim="form.buttonValue" autocomplete="off" placeholder="请输入按钮标识"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" autocomplete="off" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addBtns } from '@/api/buttons'
export default {
  props: {
    addDialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {}
      // rules: {
      //   buttonName: [
      //     { required: true, message: '按钮名称不能为空', trigger: 'blur' },
      //     { min: 3, max: 20, message: '按钮名称长度在 3 到 20 之间', trigger: 'blur' }
      //   ],
      //   buttonValue: [
      //     { required: true, message: '按钮标识不能为空', trigger: 'blur' },
      //     { min: 3, max: 30, message: '按钮标识长度在 3 到 30 之间', trigger: 'blur' }
      //   ]
      // }
    }
  },
  created () {

  },
  methods: {
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.form)
          addBtns(params).then((res) => {
            if (res.data.code === 200 || res.data.code === 0) {
              this.$message({
                type: 'success',
                message: '新增成功'
              })
              this.$emit('closeAddDialog', 1)
            }
          })
        } else {
          return false
        }
      })
    },
    resetForm () {
      this.$emit('closeAddDialog')
    }
  }
}
</script>

<style lang='less' scoped>

</style>
